<template>
  <div class="d-related-content__container">
    <div v-for="(item, idx) in items"
         :key="`${idx}`"
         class="d-related-content">
      <div class="d-related-content__image-wrapper">
        <img :alt="item.image.alt"
             :data-src="`${item.image.url}?height=210px`"
             :data-srcset="`${item.image.url}?height=210px 1x, ${item.image.url}?height=420px 2x`"
             class="related-case-study__image"
             :src="item.image.url">
        <div class="d-related-content__image-caption">
          <span class="d-related-content__title">{{ item.title }}</span>
        </div>
      </div>
      <div class="d-related-content__text-container">
        <sanitize-html base-element="p"
                       :dirty="item.description">
        </sanitize-html>
        <div class="d-related-content__action">
          <a v-if="item.cta"
             :href="item.cta.url"
             :target="item.cta.target">
            {{ item.cta.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SanitizeHtml from "~/Components/Common/SanitizeHtml.vue";

export default {
  name: "RelatedContent",
  components: {
    SanitizeHtml
  },
  props: {
    title: {
      type: String,
      default: null
    },
    viewAll: {
      type: Object,
      default: () => null,
      validator ( cta ) {
        return Object.keys( cta ).every( key => ["name", "target", "url"].includes( key ) );
      }
    },
    items: {
      type: Array,
      default: () => [],
      validator ( items ) {
        return items.every( item => Object.keys( item ).every( key => ["title", "description", "image", "cta"].includes( key ) ) );
      }
    }
  }
};
</script>

<style scoped lang="less">
@text: #027A7e;

.d-related {
  background-color: #fff;

  &__view-all-icon {
    padding: 2px;
  }

  &__header {
    display: flex;
    justify-content: space-between;

    &-title {
      font-size: 1.5rem;
      color: @text;
      font-weight: 600;
    }

    > a {
      font-size: 1.5rem;
      color: @text;
      border-bottom: 1px solid @text;
      text-decoration: none;
      line-height: 2rem;
      font-weight: 600;
      padding-bottom: 10px;
    }
  }

  &-content {
    background-color: #fff;
    border: 3px solid #027a7e;
    flex: 1;
    min-width: 280px;
    min-height: 295px;
    display: flex;
    flex-flow: column;

    @media ( max-width: 991px ) {
      max-width: 100%;
    }

    &__container {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;

      @media ( max-width: 991px ) {
        justify-content: center;
      }
    }

    &__image {
      &-wrapper {
        position: relative;
        height: 150px;

        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      &-caption {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba( 0, 0, 0, 0.6 );
        color: #fff;
        display: flex;
        flex-flow: column;
        align-items: flex-start;
        padding: 0.5rem 1rem 2rem;
      }
    }

    &__text-container {
      display: flex;
      justify-content: space-between;
      flex-flow: column;
      padding: 1rem 1rem 2rem;
      flex: 1 1 auto;

      > p {
        font-size: 1rem;
      }
    }

    &__action {
      display: inline-block;

      > a {
        font-size: 0.875rem;
        color: @text;
        border-bottom: 1px solid @text;
        text-decoration: none;
        line-height: 1.5rem;
        font-weight: 600;
        padding-bottom: 10px;
      }
    }
  }
}
</style>
